import React from 'react';
import CardSkeleton from '@/components/staffer/Grading/QuestionCards/CardSkeleton';

const CardListSkeleton = () => (
  <>
    <CardSkeleton />
    <CardSkeleton />
    <CardSkeleton />
  </>
);

export default CardListSkeleton;
